import mushroom from './mushroom.auth';
import KhaoSatApi from '../moduleApi/KhaoSatApi';

var NProgress = require('nprogress');
NProgress.configure({
  trickleSpeed: 1000,
  minimum: 0.2,
});

function blockUi() {
  NProgress.start();
  $("body").css("pointer-events", "none");
}

function unblockUi() {
  NProgress.done();
  Ladda.stopAll();
  $("body").css("pointer-events", "auto");
}

window.requestCount = 0;

// đăng nhập
let AuthService = {};

AuthService.login = (account, password, remember) => {
  blockUi();
  return mushroom.$auth.loginAsync(account, password, remember)
    .then(response => {
      unblockUi();
      // console.log("Đăng nhập thành công, token: " + response.token);
      return response;
    })
    .catch(error => {
      unblockUi();
      // console.log("Đăng nhập thất bại: %o", error);
      throw error;
    });
};
AuthService.login_v2 = (account, password, card_code, remember) => {
  blockUi();
  return mushroom.$auth.loginV2Async(account, password, card_code, remember)
    .then(response => {
      unblockUi();
      // console.log("Đăng nhập thành công, token: " + response.token);
      return response;
    })
    .catch(error => {
      unblockUi();
      // console.log("Đăng nhập thất bại: %o", error);
      throw error;
    });
};
AuthService.loginOnelink = (account, password, remember) => {
  blockUi();
  return mushroom.$auth.loginOneLinkAsync(account, password, remember)
    .then(response => {
      unblockUi();
      // console.log("Đăng nhập thành công, token: " + response.token);
      return response;
    })
    .catch(error => {
      unblockUi();
      // console.log("Đăng nhập thất bại: %o", error);
      throw error;
    });
};

AuthService.loginBs = async (account, password, remember) => {
  blockUi();
  let res = await AuthService.login('tichhop', 'tichhop', true);
  if (res.result && res.result.token) {
    let res_login = await mushroom.$auth.loginRoleAsync(account, password, res.result.token, remember);
    if (res_login) {
      let res_infoBS = await KhaoSatApi.LoadDMUserByUserName(account, res.result.token);
      window.localStorage.setItem("currentUserBS", JSON.stringify(res_infoBS.data[0] ? res_infoBS.data[0] : {}))
      unblockUi();
      // console.log("Đăng nhập thành công");
      return res_infoBS;
    }
    else {
      unblockUi();
      // console.log("Đăng nhập thất bại");
      throw false;
    }

  }
  else {
    throw false;
  }


};

// đăng xuất
AuthService.logout = (logoutAll) => {
  blockUi();
  return mushroom.$auth.logoutAsync({
    mode: logoutAll ? "invalidAllSession" : "invalidClientSession"
  })
    .then(response => {
      unblockUi();
      // console.log("Đã logout");
      return response;
    })
    .catch(error => {
      unblockUi();
      // console.log("Có lỗi: %o", error);
      throw error;
    });
};

// Kiểm tra trạng thái đăng nhập
AuthService.status = () => {
  return mushroom.$auth.statusAsync()
    .then(response => {
      // console.log("status = " + response.status);
      return response.status;
    })
    .catch(error => {
      // console.log("Có lỗi: %o", error);
      throw error;
    });
};

// Lấy về thông tin người dùng hiện tại
AuthService.me = () => {
  return mushroom.$auth.meAsync()
    .then(response => {
      // console.log("response data: %o", response);
      return response;
    })
    .catch(error => {
      // console.log("Có lỗi: %o", error);
      throw error;
    });
};

// đăng ký
AuthService.register = (account, password) => {
  return mushroom.$auth.registerAsync(account, password)
    .then(response => {
      if (response.requireActivation) {
        // console.log("Đăng ký thành công, bạn hãy checkmail để kích hoạt tài khoản");
      }
      else {
        // console.log("Đăng ký thành công");
      }
      return response;
    })
    .catch(error => {
      // console.log("Đăng ký thất bại: %o", error);
      throw error;
    });
};

// kick hoạt tài khoản
AuthService.activate = (account, activationCode) => {
  return mushroom.$auth.activateAsync(account, activationCode)
    .then(response => {
      console.log("Kích hoạt thành công");
      return response;
    })
    .catch(error => {
      console.log("Kích hoạt thất bại: %o", error);
      throw error;
    });
};

// lấy lại mật khẩu
AuthService.recoverPassword = (account) => {
  return mushroom.$auth.recoverPasswordAsync(account)
    .then(response => {
      console.log("Bạn hãy check mail để lấy mật khẩu");
      unblockUi();
      return response;
    })
    .catch(error => {
      console.log("Có lỗi: %o", error);
      unblockUi();
      throw error;
    });
};

AuthService.oneLinkRecoverPassword = (account, phoneNumber) => {
  return mushroom.$auth.onelinkRequestRecoverPasswordAsync(account, phoneNumber)
    .then(response => {
      unblockUi();
      return response;
    }).catch(error => {
      unblockUi();
      throw error;
    })
}

// khôi phục mật khẩu
AuthService.resetPassword = (account, code, newPassword) => {
  return mushroom.$auth.resetPasswordAsync(account, code, newPassword)
    .then(response => {
      console.log("Đã đặt lại mật khẩu dựa trên mã khôi phục mật khẩu");
      unblockUi();
      return response;
    })
    .catch(error => {
      console.log("Có lỗi: %o", error);
      unblockUi();
      throw error;
    });

};

AuthService.oneLinkResetPassword = (account, phoneNumber, code, newPassword) => {
  return mushroom.$auth.onelinkRecoverPasswordAsync(account, phoneNumber, code, newPassword)
    .then(response => {
      unblockUi();
      return response;
    })
    .catch(error => {
      unblockUi();
      throw error;
    })
}

// đổi mật khẩu
AuthService.changePassword = (account, password, newPassword) => {
  return mushroom.$auth.changePasswordAsync(account, password, newPassword)
    .then(response => {
      console.log("Đã đổi mật khẩu thành công");
      return response;
    })
    .catch(error => {
      console.log("Có lỗi: %o", error);
      throw error;
    });
};

// đổi mật khẩu admin
AuthService.changePasswordAdmin = (account, password, newPassword) => {
  return mushroom.$auth.changePasswordAdminAsync(account, password, newPassword)
    .then(response => {
      console.log("Đã đổi mật khẩu thành công");
      return response;
    })
    .catch(error => {
      console.log("Có lỗi: %o", error);
      throw error;
    });
};

//check tài khoản đã kích hoạt
AuthService.checkActive = (account) => {
  return mushroom.$auth.checkActiveAsync(account)
    .then(response => {
      console.log(response);
      return response;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};

//request otp
AuthService.requestActiveCode = (account, phoneNumber) => {
  return mushroom.$auth.requestActivateCodeAsync(account, phoneNumber)
    .then(response => {
      console.log(response);
      return response;
    })
    .catch(error => {
      console.log(error);
      throw error;
    });
};

//active account
AuthService.ActiveAccount = (account, code, password) => {
  return mushroom.$auth.activateAccountAsync(account, code, password)
    .then(response => {
      return response;
    })
    .catch(error => {
      throw error;
    })
};


export default AuthService;